









import { defineComponent, type PropType } from "vue-demi";

export default defineComponent({
  props: {
    price: {
      type: Number as PropType<number>,
      required: true,
    },
    discount: {
      type: Number as PropType<number>,
      required: true,
    },
  },
  computed: {
    percent() {
      if (this.price !== 0 && this.discount !== 0) {
        return Math.ceil(((this.price - this.discount) / this.price) * 100);
      } else {
        return 0;
      }
    },
    color() {
      if (this.percent > 0) {
        if (this.percent < 20) {
          return "green";
        } else if (this.percent < 40) {
          return "light-green";
        } else if (this.percent < 60) {
          return "yellow";
        } else if (this.percent < 80) {
          return "orange";
        } else if (this.percent < 85) {
          return "pink";
        } else if (this.percent >= 85) {
          return "red";
        }
      }

      return null;
    },
  },
});
